import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import DependabotMappingForm from './DependabotMappingForm';
import _ from 'lodash';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

const DependabotCredentialsForm = forwardRef((props, ref) => {
    const featureFlags = useFeatureFlag();
    const fields = [
        ...(featureFlags.ENABLE_GHAS_FOR_ENTERPRISE ? [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator],
        }] : []),
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        },
        {
            name: 'showFork',
            type: FieldTypes.BOOLEAN,
            label: 'Show Fork Repository',
            inline: true
        }
    ];
    const config = useMemo(() => {
        if(_.isEmpty(props.config)){
            return undefined;
        }
        return {
            ...props.config,
            showFork: props.config.showFork === "true"
        }
    }, [props.config])
    
    return (
        <GenericPullCredentialsForm 
         {...props}
         config={config} 
         ref={ref}
         fields={fields}
         toolDisplayName="GitHub Dependabot"
         versionField={false} 
         MappingForm={DependabotMappingForm}
         initialValue={{ apiEndpoint: 'https://api.github.com' }}
          />
    )
});

export default DependabotCredentialsForm;
